import {
    CLEAR_MODULE_SECTION_ERROR,
    CLEAR_MODULE_SECTION_MESSAGE,
    CREATE_MODULE_SECTION_FAIL,
    CREATE_MODULE_SECTION_SUCCESS,
    DELETE_MODULE_SECTION_FAIL,
    DELETE_MODULE_SECTION_SUCCESS,
    GET_MODULE_SECTIONS_FAIL,
    GET_MODULE_SECTIONS_SUCCESS,
    REORDER_MODULE_SECTIONS_FAIL,
    REORDER_MODULE_SECTIONS_SUCCESS,
    SET_MODULE_SECTION_ERROR,
    SET_MODULE_SECTION_LOADING,
    UPDATE_MODULE_SECTION_FAIL,
    UPDATE_MODULE_SECTION_SUCCESS,
} from "../actions/moduleCleSectionActions";

const initialState = {
    loading: false,
    error: null,
    message: null,
    items: [],
    currentModuleCleId: null,
};

export default function moduleCleSectionReducer(state = initialState, action) {
    switch (action.type) {
        case SET_MODULE_SECTION_LOADING:
            return { ...state, loading: action.payload };
        case SET_MODULE_SECTION_ERROR:
            return { ...state, error: action.payload };
        case CLEAR_MODULE_SECTION_ERROR:
            return { ...state, error: null };
        case CLEAR_MODULE_SECTION_MESSAGE:
            return { ...state, message: null };
        case GET_MODULE_SECTIONS_SUCCESS:
            return {
                ...state,
                items: action.payload.items || [],
                currentModuleCleId: action.payload.moduleCleId,
                error: null,
            };
        case CREATE_MODULE_SECTION_SUCCESS:
            return { ...state, message: "Section créée avec succès.", error: null };
        case UPDATE_MODULE_SECTION_SUCCESS:
            return { ...state, message: "Section mise à jour avec succès.", error: null };
        case DELETE_MODULE_SECTION_SUCCESS:
            return {
                ...state,
                items: state.items.filter((item) => item.id !== action.payload.sectionId),
                message: "Section supprimée avec succès.",
                error: null,
            };
        case REORDER_MODULE_SECTIONS_SUCCESS:
            return {
                ...state,
                items: action.payload.items || [],
                currentModuleCleId: action.payload.moduleCleId,
                message: "Ordre des sections mis à jour.",
                error: null,
            };
        case GET_MODULE_SECTIONS_FAIL:
        case CREATE_MODULE_SECTION_FAIL:
        case UPDATE_MODULE_SECTION_FAIL:
        case DELETE_MODULE_SECTION_FAIL:
        case REORDER_MODULE_SECTIONS_FAIL:
            return { ...state, error: action.payload };
        default:
            return state;
    }
}
